export default __webpack_public_path__ + "static/media/leftArrowWall.68a65e11.svg";